export default {
  de: {
    inProgress: 'Der Wahlen-Bereich wird aktuell gewartet.',
  },
};
